import { useMutation } from "urql";

import { UpdatePaymasterDocument } from "../../../graphql/generated.ts";

export function useUpdatePaymaster() {
  return useMutation(UpdatePaymasterDocument);
}
